import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import { CommunityGuard } from '@src/components/guard/CommunityGuard';
import { useSharedAuth } from '@src/context/auth/useSharedAuth';
import CommunityChatSearchForm from '@src/features/shared/community/CommunityChatSearchForm';
import CommunityDefaultLayout from '@src/layouts/shared/CommunityDefaultLayout';

function CommunityChatSearch() {
  const sharedAuth = useSharedAuth();
  const profile = sharedAuth.profile?.isTenant
    ? sharedAuth.profile?.tenantProfile
    : sharedAuth.profile?.companyProfile;

  return (
    <CommunityGuard
      profile={profile}
      isTenant={sharedAuth.profile?.isTenant ?? false}
      canService={[SERVICE.ONLINE_COMMUNITY]}
      checkAuthenticate={true}
      redirectToErrorPageWhenNotAuthenticated={true}
      checkHasParticipatingChannels={true}
      checkAccessibleNotPublicChannel={false}
      isProfileLoading={sharedAuth.isLoading}
    >
      <CommunityDefaultLayout>
        <CommonHelmet />
        <CommunityChatSearchForm profile={profile} />
      </CommunityDefaultLayout>
    </CommunityGuard>
  );
}

export default CommunityChatSearch;
